module.exports = __webpack_public_path__ + "img/dep_clothingandaccessories.f77aaad6.png";